export default "__VITE_ASSET__iqrnYJev__"